(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["news-list"] && !Shopify.designMode) return;
  try {
    
// liタグの要素を取得

function changeBgColor() { // 関数化
  let titles = document.getElementsByClassName("newsTitle"); // spanタグの配列を取得
  for (let i = 0; i < titles.length; i++) { // 配列の要素数だけ繰り返す
    let newsTitle = titles[i].innerHTML; // spanタグ内のテキストを取得
    if (newsTitle == "製品情報") {
      titles[i].style.backgroundColor = "#8cc63f"; 
    } else if (newsTitle == "お知らせ") {
      titles[i].style.backgroundColor = "#29abe2"; 
    } else if (newsTitle == "イベント") {
      titles[i].style.backgroundColor = "#f7931e"; 
    }
  }
    
  let li = document.getElementsByTagName("li");

  // テキストの内容を指定
  let ignoredTags = ["製品情報", "お知らせ", "イベント"];

  // liタグの数だけ繰り返す
  for (let i = 0; i < li.length; i++) {
    let found = false;
    for (let j = 0; j < ignoredTags.length; j++) {
      if (li[i].textContent.includes(ignoredTags[j])) {
        found = true;
        break;
      }
    }
    if (!found) {
      // 製品情報、お知らせ、イベント以外のタグを削除する
      li[i].parentNode.removeChild(li[i]);
    }
  }  
}

window.addEventListener("DOMContentLoaded", function() {
  changeBgColor();
});


    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
